import Cookies from 'js-cookie';
import Modal from 'javascripts/components/Modal';
import React from 'react';
import UkSkylineImage from 'images/uk/about/UK_Skyline.png';
import t from 'javascripts/utils/translation';

class CountryIntercept extends React.Component {
  componentDidMount = () => {
    $.getJSON(`//${window.host}/api/v1/geoip`, (response) => {
      if(response.country === this.props.countryToDetect) this.toggleModal();
    });
  }

  onContinueDeny = () => {
    this.modal.toggle();
  }

  onContinueAccept = () => {
    const cookieCountry = this.props.countryToDetect == 'GB' ? 'UK' : 'US';
    Cookies.set('countrypreference', cookieCountry, { expires: 365, domain: this.cookieDomain() });
    window.location = this.props.continueUrl;
  }

  toggleModal = () => {
    this.modal.toggle();
    window.analytics.track(`Opened Continue to ${this.props.countryToDetect} modal`, {});
  }

  cookieDomain = () => {
    const domain = '.charitywater.org';
    return (this.getHostName().indexOf(domain) !== -1) ? domain : this.getHostName();
  };

  getHostName = () => window.location.hostname;

  render() {
    return (
      <div>
        <Modal
          modalId='uk-intercept'
          modalInnerClassName='overflow-hidden text-center'
          ref={el => this.modal = el}
        >
          <h1 className='h40'>
            {t('views.country_intercept.title')}
          </h1>
          <p
            className='p40 my-2'
            dangerouslySetInnerHTML={{__html: t('views.country_intercept.message')}}
          />
          <a
            className='button button--outline-blue cancel md-mr-1'
            href='#'
            onClick={this.onContinueDeny}
          >
            {t('views.country_intercept.stay_button')}
          </a>
          <a
            className='button button--cw-blue continue md-ml-1 sm-mt-2'
            href='#'
            onClick={this.onContinueAccept}
          >
            {t('views.country_intercept.continue_button')}
          </a>

          {this.props.countryToDetect === 'GB' &&
            <img
              className='-mb-4 mt-2'
              src={UkSkylineImage}
            />
          }
        </Modal>
      </div>
    );
  }
}

export default CountryIntercept;
